import { useState } from 'react'

export function Footer() {
  const [disclaimerOpen, setDisclaimerOpen] = useState(false)
  return (
    <footer className="mt-10 pt-6 border-t border-ink-100 container-mobile text-ink-500 text-sm leading-relaxed">
      <div className="flex items-center gap-2 mb-3">
        <img src="/logo_1.png" alt="方法星球" className="h-7 w-7 rounded" />
        <span className="text-ink-700">方法星球</span>
      </div>

      <button
        onClick={() => setDisclaimerOpen((v) => !v)}
        className="text-brand-700 active:opacity-70"
      >
        {disclaimerOpen ? '收起免责声明 ▴' : '查看免责声明 ▾'}
      </button>

      {disclaimerOpen && (
        <div className="mt-3 space-y-2 text-ink-600">
          <p>1. 本工具为志愿决策辅助参考，最终录取以邹城市教育和体育局公告及实际录取结果为准。</p>
          <p>2. 模型基于公开规则的统计学预测，结果为概率估计，不代表实际录取结果，亦不构成填报建议。</p>
          <p>3. 报名偏好数据基于本地教研经验先验估计，可能与当年实际报名情况存在偏差。</p>
          <p>4. 录取以学业考试科目及综合素质评价等级达到 C（含 C）级以上为前提，本工具不校验该条件。</p>
          <p>5. 分数计算全部在用户本地浏览器进行，不上传任何身份信息。</p>
          <p>6. 因使用本工具产生的任何后果由用户自行承担。</p>
        </div>
      )}

      <div className="mt-4 text-xs">
        ZSM-1 模型 · 2026 版本 · © 方法星球
      </div>
    </footer>
  )
}
